import Viewer from 'viewerjs'
import _ from 'lodash'

export default (el, opts = {}) => {
  this.opts = {
    filter (img) {
      if (img.dataset['preview'] && img.src) {
        return true
      }
      return false
    }
  }
  this.opts = _.merge({}, this.opts, opts)
  return new Viewer(el, this.opts)
}



// WEBPACK FOOTER //
// ./src/utils/directives/viewer.js